<div class="flex-container top-container">
  <div>
    <h1>{{ sectionName }}
      <ng-container *ngIf="dataIn.section === null">
        {{(dataIn.projectValidation.complete ? '(valid)' : '(invalid)')}}
      </ng-container>
    </h1>
    <mat-tree class="progress-mat-tree"
              [dataSource]="dataSource"
              [treeControl]="treeControl">
      <!-- This is the tree node template for leaf nodes -->
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding
                     (click)="navigateToLocation(node.path)"
                     [ngClass]="node.valid ? 'valid-color' : 'invalid-color'"

      >
        <button mat-icon-button disabled></button>
        <div>{{ node.name | anessaTranslation }}</div>
        <ng-container *ngIf="!node.valid">
          <i class="material-icons red icon-margin"
             [matTooltip]="getFormattedErrMsgs(node)"
          >
            error_outline
          </i>
        </ng-container>
      </mat-tree-node>
      <!-- This is the tree node template for expandable nodes -->
      <mat-tree-node *matTreeNodeDef="let node;when: hasChild"
                     matTreeNodePadding (click)="navigateToLocation(node.path)"
                     [ngClass]="node.valid ? 'valid-color' : 'invalid-color'"
      >
        {{expandNode(node)}}
        <button mat-icon-button matTreeNodeToggle
                [attr.aria-label]="'toggle ' + node.name"
                [attr.aria-level]="node.level">
          <mat-icon class="mat-icon-rtl-mirror">
            {{treeControl.isExpanded(node) ? 'expand_less' : 'expand_more'}}
          </mat-icon>
        </button>
        <div>{{ node.name | anessaTranslation }}</div>
      </mat-tree-node>
    </mat-tree>
  </div>
  <div class="buttongroup confirm-button">
    <button
      *ngIf="!dataIn.disableConfirmClose"
      mat-button
      (click)="close()"
      anessaTranslation="PROJECT.COMMON.CONFIRM"
    ></button>
  </div>
</div>
